import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Charm from '../components/Matrix/ExploreViewCharm';

import DifficultySelectionButton from '../components/DifficultySelectionButton'


import sampleProjects from '../data/SampleProjects';


class Explore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sample_projects: sampleProjects().sample_projects,
            levels: sampleProjects().sample_project_difficulty_levels,
            selected_levels: [0]
        }
    }

    handleLevelSelectionChange = (id) => {
       
        let levels = this.state.selected_levels

        if (levels.includes(id)){
 
            levels = levels.filter(level => level!== id)
        }
        else {

            levels.push(id)
        }

        this.setState({
            selected_levels:levels
        })
    }


    displaySelectionButtons = () => {


        return (
            <div style={{display:"flex", justifyContent:"center"}}>
                {this.state.levels.map((level, index) =>
                <DifficultySelectionButton chosen_buttons={this.state.selected_levels} button_id={index} onClick={this.handleLevelSelectionChange} key={index}>{level}</DifficultySelectionButton>)}
            </div>
        )

    }

    displayProjects = () => {


        let allProjects =[]

        for (let i=0; i < this.state.selected_levels.length; i++){
            allProjects = allProjects.concat(this.state.sample_projects[this.state.selected_levels[i]])
        }


        return (



            <div style={{ display: "flex", justifyContent: "space-evenly", flexWrap: "wrap", alignContent: "flex-start", marginTop:"2%" }}>
                {allProjects.map((project, index) =>

                        <Link key={index} style={{textDecoration:'none'}} to={{ pathname: '/app/create', state: {projectCode: project.code, privateTitle: project.title} }}>
                            <div  style={{position: "relative", marginRight: "1%", marginBottom: "1%" }}>
                                <div style={{position: "absolute", top: 0, zIndex: 3, width: 214, height: 214}}></div>
                                <Charm data={project.codeResult.animation.frames} pixel_size={25} title={project.title} difficulty={project.difficulty}/>
                             </div>
                        </Link>
                    
                )}

            </div>

        )

    }


    render() {
        return (
            <div style={{marginLeft:"5%", marginRight:"5%", marginTop:"2%"}}>

                {this.displaySelectionButtons()}

                {this.displayProjects()}

            </div>


        )
    }
}
export default Explore;